import { useAuthStore } from 'src/domain/stores/useAuthStore';
import { ScrollView, StyleSheet, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import MenuRow from 'src/presentation/components/molecules/MenuRow';
import ThermenImage from 'src/presentation/components/molecules/ThermenImage';
import { SvgIconType } from '@thermenresorts/icons';
import type { StackNavigationProp } from '@react-navigation/stack';
import type { AccountNavigation } from 'src/presentation/navigation/types/NavigationTypes';
import Dimens from 'src/core/utils/Dimens';
import Styles from 'src/core/utils/Styles';
import Constants from 'src/core/utils/Constants';
import { localeFlag } from 'src/core/utils/Locales';
import Translations from 'src/core/utils/Translations';

export default function PreferencesScreen() {
	const navigation = useNavigation<StackNavigationProp<AccountNavigation>>();
	const { language } = useAuthStore();

	return (
		<View style={Styles.screen.white}>
			<ScrollView>
				<MenuRow
					detailText={Translations.accountPreferencesNewsletterDetail}
					icon={SvgIconType.mail}
					label={Translations.accountPreferencesEmails}
					onPress={() => navigation.navigate(Constants.screenMailPreferences)}
				/>
				<MenuRow
					detailText={Translations.accountPreferencesLanguageDetail}
					imageComponent={<ThermenImage source={localeFlag(language)} style={styles.flag} />}
					label={Translations.accountPreferencesPreferredLanguage}
					onPress={() => navigation.navigate(Constants.screenLanguagePreferences)}
				/>
			</ScrollView>
		</View>
	);
}

const styles = StyleSheet.create({
	flag: {
		width: Dimens.size16,
		height: Dimens.size12,
		marginTop: Dimens.padding3,
	},
});
